export default __webpack_public_path__ + "static/media/upload.918d2c4d.svg";